<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                data-vv-rules="required|min_value:1|max_value:24"
                data-vv-name="hours"
                data-vv-value-path="inputValue"
                :errorText="errors.first('hours')"
                :label="$t('message.labelHours')"
                :hintText="$t('message.placeholderText')"
                v-model.number="reading.hours"
                fullWidth></mu-text-field>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-text-field
                v-validate
                data-vv-rules="required|min_value:1|max_value:10"
                data-vv-name="quality"
                data-vv-value-path="inputValue"
                :errorText="errors.first('quality')"
                type="number"
                :label="$t('message.cardSleepQuality')"
                :hintText="$t('message.placeholderText')"
                v-model.number="reading.quality"
                fullWidth
              ></mu-text-field>
            </mu-col>

          </mu-row>

          <vue-slider style="padding-left: 0;" class="bottom" v-bind="sliderSettings"
                      v-model="reading.quality"></vue-slider>
        </mu-col>
      </mu-row>

      <mu-row gutter>

      </mu-row>


    </div>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <button type="submit" style="display: none;"></button>
    <mu-raised-button
      @click.native="submitForm"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>

  let sliderSettings = {
    min: 0,
    max: 10,
    tooltipDir: "right",
    bgStyle: {
      "backgroundColor": "#fff",
      "boxShadow": "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
    },
    processStyle: {
      "backgroundImage": "-webkit-linear-gradient(left, #183A43, #183A43)"
    },
    sliderStyle: [
      {
        "backgroundColor": "#CCCCCC"
      }
    ],
    model: {
      hours: 10,
      quality: 5
    }
  };



  import SleepApi from '../../../../api/Tracking/Sleep'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'
  import vueSlider from 'vue-slider-component/src/vue2-slider.vue'


  export default {
    components: {vueSlider},
    mixins: [TrackingEditMixin],
    name: 'sleep-edit',
    props: {
      item: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        sliderSettings: sliderSettings,
        isUpdating: false,
        reading: {}
      }
    },
    mounted() {
      let self = this;
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid) {
            self.isUpdating = true;
            SleepApi.putSleepTracking(self.reading)
              .then(function (response) {
                let offset = new Date();
                self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes')
                self.$emit('updateReading', self.reading);
                self.$emit('closeEditPanel');
                self.isUpdating = false;
              });
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SleepEdit.vue?4443c097